import { matchMedium } from '../utils/breakpoints'

const rellaxItems = document.querySelectorAll('.rellax')

if (rellaxItems.length > 0 && !matchMedium().matches) {
  import(/* webpackChunkName: "rellax" */ 'rellax').then(
    ({ default: Rellax }) => {
      new Rellax('.rellax', {
        speed: 1
      })
    }
  )
}
